import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import "./style.css";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Divider from '@mui/material/Divider';
import PropagateLoader from "react-spinners/PropagateLoader";
import LockIcon from '@mui/icons-material/Lock';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


export default function Login(){
    const [full_name,setFull_Name] = useState("")
    const [nik,setNik] = useState("")
    const [bDate,setbDate] = useState("")
    const [username,setName] = useState("")
    const [password,setPass] = useState("")
    const [error,setError] = useState("")
    const [success,setSuccess] = useState("")
    const [loading,setLoading] = useState(false)
    const [confirmpass,setConfirmPass] = useState("")

    const registerSubmit=async()=>{

    }
    
    async function postName(e){
        setLoading(true)
        e.preventDefault()

        try{
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/signup`,{
            full_name ,bDate, nik, username, password, confirmpass
        });
        setLoading(false)
        setSuccess("Signup Berhasil")
        setError("")
        setFull_Name("")
        setNik("")
        setbDate("")
        setName("")
        setPass("")
        setConfirmPass("")
        }catch(error){
        setLoading(false);
        setSuccess("")
        setError(error.response.data.message)
        }
    };
    
    return  <Grid container justifyContent="center"  align="center" alignItems="center">
                <Grid item lg={3} p={3} align="center" justifyContent="center">
                    <h3 justifyContent="center">SignUp Backend</h3>
                    <form onSubmit={postName}>
                    <TextField sx={{ mt: 2 }} variant="outlined" type="text" value={full_name} onChange={(e) => setFull_Name(e.target.value)} fullWidth label="Nama Lengkap"/>
                    <TextField sx={{ mt: 2 }} type="text" value={nik} onChange={(e) => setNik(e.target.value)}  fullWidth variant="outlined" label="NIK/KTP"/>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker views={['day','month', 'year']} inputFormat="dd/MM/yyyy"
                        label="Tanggal Lahir"
                        value={bDate}
                        onChange={(e) => {
                            setbDate(e);
                        }}
                        renderInput={(params) => <TextField fullWidth sx={{ mt: 2 }}  {...params} InputProps={{endAdornment: (
                        <InputAdornment position="end">
                            <CalendarMonthIcon />
                        </InputAdornment>
                    ),
                    }}/>}

                        />
                        </LocalizationProvider>
                    
                    <Divider sx={{ my: 3 }} />
                    <TextField type="text" sx={{ mt: 2 }} value={username} onChange={(e) => setName(e.target.value)} variant="outlined" fullWidth label="username"/>
                    <TextField type="password" sx={{ mt: 2 }}  fullWidth  label="Password" variant="outlined" value={password} onChange={(e) => setPass(e.target.value)} InputProps={{endAdornment: (
                        <InputAdornment position="end">
                            <LockIcon />
                        </InputAdornment>
                    ),
                    }}/>
                    <TextField type="password" sx={{ mt: 2 }}  value={confirmpass} onChange={(e) => setConfirmPass(e.target.value)} iconEnd={<LockIcon />} fullWidth variant="outlined" label="Confirm Password" InputProps={{endAdornment: (
                        <InputAdornment position="end">
                            <LockIcon />
                        </InputAdornment>
                    ),
                    }}/>
                    <Button sx={{ mt: 2 }} type="submit" variant="contained">SignUp</Button>
                    <PropagateLoader color="#1876f2" loading={loading} size={10}/>
                    {error && <div className="error_text">{error}</div>}
                    {success && <div className="success_text">{success}</div>}
                    </form>
                </Grid>

            </Grid>
    
    
    
    
    // <div container className="align-items-center d-flex">
    //         <div className="container col-lg-3 col-md-5 white justify-content-center p-5 align-items-center">
    //              <h1 className="text-center mb-2 align-items-center">Login Backend</h1>
    //              <input type="text" name="username" className="form-control mt-5" autocomplete="off" placeholder="username"/>
    //              <input type="password" name="password" className="form-control mt-2 " autocomplete="off" placeholder="password"/>
    //              <Button type="submit" variant="contained" className="btn btn-success mt-4 col-12" name="button">Login</Button>
                
    //          </div>
    //     </div>
    
   

    
    // <div container>
    //         <div className="container col-lg-3 col-md-5 white justify-content-center p-5 align-items-center">
    //             <h1 className="text-center mb-2">Login Backend</h1>
    //             <input type="text" name="username" className="form-control mt-5" autocomplete="off" placeholder="username"/>
    //             <input type="password" name="password" className="form-control mt-2" autocomplete="off" placeholder="password"/>
    //             <Button type="submit" variant="contained" className="btn btn-success mt-4 col-12" name="button">Login</Button>
                
    //         </div>
    //     </div>
};